import { checkUserPermissionFunc } from "../components/common/CommonFunctions";

const WEB_ONLY_NOTIFICATION_TYPES = new Set(["Hostel", "HR Planning"]);

const GRIEVANCE_TYPES = new Set([
  "Grievance Raised",
  "Grievance Acknowledged",
  "Grievance Updated",
  "Grievance Information Requested",
  "Grievance Resolved",
  "Grievance Escalated",
  "Grievance Reopened",
  "Grievance SLA Breached",
]);

const RAISER_GRIEVANCE_TYPES = new Set([
  "Grievance Acknowledged",
  "Grievance Information Requested",
  "Grievance Resolved",
]);

const grievancePath = (base, typeId) =>
  typeId ? `${base}?id=${encodeURIComponent(typeId)}` : base;

/**
 * Resolve a deep-link route for a notification row.
 */
export const getNotificationRoute = (notification) => {
  const action = notification?.notification_action;
  const type = notification?.notification_type;
  const isAdmin = JSON.parse(sessionStorage.getItem("is_admin") || "false");
  const isReportingManager = JSON.parse(sessionStorage.getItem("reportingManager") || "false");

  if (action === "view_grievance" || GRIEVANCE_TYPES.has(type)) {
    const typeId = notification?.type_id;
    if (RAISER_GRIEVANCE_TYPES.has(type)) {
      return grievancePath("/grievance/my-grievances", typeId);
    }
    const { permission } = checkUserPermissionFunc("grievance", "Grievance Inbox", "SubMenu") || {};
    const isOrgAdmin = JSON.parse(sessionStorage.getItem("is_super_admin") || "false");
    if (permission || isOrgAdmin) {
      return grievancePath("/grievance/inbox", typeId);
    }
    return grievancePath("/grievance/my-grievances", typeId);
  }

  if (action === "attendance_log") return "/attendance/attendancelog";
  if (action === "punch_discrepancies") return "/attendance/punch-discrepancies";
  if (action === "dashboard") return "/home";
  if (action === "occupancy" || type === "OccupancyShortage") return "/employee/occupancy";
  if (action === "view_training") return "/training";

  const employeeRoutes = {
    Leave: "/employee/leaverequest",
    Reimbursement: "/employee/reimbursementrequest",
    Advance: "/employee/advancerequest",
    Overtime: "/employee/overtimerequest",
    Resignation: "/employee/resignationrequest",
    Timesheet: "/employee/timesheet",
    Asset: "/assetmanagement/assetrequest",
  };

  const approvalActions = new Set(["request"]);
  const employeeActions = new Set(["approved", "rejected", "cancelled", "processed"]);

  if (type === "Timesheet" && approvalActions.has(action) && (isAdmin || isReportingManager)) {
    return "/employee/team/timesheet";
  }

  if (approvalActions.has(action) && (isAdmin || isReportingManager)) {
    return "/employee/approvalinbox";
  }

  if (employeeActions.has(action) && employeeRoutes[type]) {
    return employeeRoutes[type];
  }

  if (type === "Appraisal Assigned" || type === "Appraisal Published") {
    return "/appraisal/my-appraisal";
  }

  if (type === "Training Assigned" || type === "Training Overdue") {
    return "/training";
  }

  if (type === "Transfer Reporting Manager") {
    return "/employee/transfer-reporting-manager";
  }

  if (type === "AttendanceException") {
    return "/attendance/attendancelog";
  }

  if (type === "AttendanceExceptionManager" || type === "AttendanceDiscrepancy") {
    return "/attendance/punch-discrepancies";
  }

  if (type === "System") {
    return "/home";
  }

  if (type === "Payroll") {
    const { permission } = checkUserPermissionFunc("payroll", "Payslips", "SubMenu") || {};
    return permission ? "/payroll/payslips" : "/employeeprofile";
  }

  if (type === "Shift Change") {
    return isAdmin || isReportingManager
      ? "/attendance/shift-change-requests"
      : "/home";
  }

  if (type === "BirthdayAlert") {
    return "/home";
  }

  if (type === "Exit") {
    return "/employee/resignationrequest/process";
  }

  if (approvalActions.has(action)) {
    return "/employee/approvalinbox";
  }

  if (WEB_ONLY_NOTIFICATION_TYPES.has(type)) {
    return "/home";
  }

  return null;
};
